import { absolutePath } from "./absolutePath";

interface CommentsFnProps {
  id?: string | number;
  params?: Record<string, unknown>;
  postId?: string | number;
}

export const comments = {
  show: ({ postId, id, params = {} }: CommentsFnProps = {}) =>
    absolutePath(`posts/${postId}/comments/${id}`, params),
  index: ({ postId, params = {} }: CommentsFnProps = {}) =>
    absolutePath(`posts/${postId}/comments`, params),
  create: ({ postId, params = {} }: CommentsFnProps = {}) =>
    absolutePath(`posts/${postId}/comments`, params),
  update: ({ postId, id, params = {} }: CommentsFnProps = {}) =>
    absolutePath(`posts/${postId}/comments/${id}`, params),
  destroy: ({ postId, id, params = {} }: CommentsFnProps = {}) =>
    absolutePath(`posts/${postId}/comments/${id}`, params),
  commentHierarchy: ({ postId, id, params = {} }: CommentsFnProps = {}) =>
    absolutePath(`posts/${postId}/comments/${id}/comment_hierarchy`, params),
  userLikes: ({ id, params = {} }: CommentsFnProps) =>
    absolutePath(`comments/${id}/user_likes`, params),
};
